import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
      marginTop: theme.spacing(1)
    },
  },
}));
const LabelDestinos = (props) => {
  const { Destinos = [] } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {Destinos.map((item, index) =>
        <Chip
          variant="outlined"
          color="primary"
          key={index}
          label={item.Nombre}
          size="small"
        />
      )}
    </div>
  );
};
export default LabelDestinos;
